<div class="agent-status-dropdown text-body">
  <div class="py-1">
    @for (item of statusItems(); track item.id) {
      <button
        type="button"
        class="agent-status-item btn w-100 d-flex align-items-center justify-content-between gap-2 border-0 rounded-0 shadow-none px-2 py-2 text-start"
        [class.bg-body-tertiary]="item.id === currentStateId"
        [class.fw-semibold]="item.id === currentStateId"
        [class.text-body-secondary]="item.isDisabled && item.id !== currentStateId"
        [class.opacity-75]="item.isDisabled && item.id !== currentStateId"
        [disabled]="item.isDisabled"
        (click)="onItemClick(item)">
        <span class="d-inline-flex align-items-center gap-2 flex-grow-1 overflow-hidden">
          <span
            class="agent-status-dot d-inline-block rounded-circle flex-shrink-0"
            [ngClass]="item.dotClass"></span>
          <span class="small text-truncate">
            @if (item.displayName) {
              {{ item.displayName }}
            } @else {
              {{ item.labelKey | abpLocalization }}
            }
          </span>
        </span>

        <span class="d-inline-flex align-items-center justify-content-end flex-shrink-0">
          @if (item.id === currentStateId) {
            <i class="fas fa-check text-primary"></i>
          } @else if (item.isAuto) {
            <span
              class="badge rounded-pill border small fw-semibold text-body-secondary bg-body-tertiary">
              {{ 'AgentDesktop::AgentStatus:Auto' | abpLocalization }}
            </span>
          } @else if (item.id === queuedNextStateId) {
            <span
              class="queued-status-badge badge rounded-pill small fw-semibold d-inline-flex align-items-center gap-1">
              <span>{{ 'AgentDesktop::AgentStatus:Next' | abpLocalization }}</span>
              <i class="fas fa-times small" aria-hidden="true"></i>
            </span>
          }
        </span>
      </button>
    }
  </div>
</div>
